import {
  Environment,
  EnvironmentInfo,
  EnvironmentLink
} from 'types/environment';

const ENVIRONMENT_DETAILS: Record<
  Environment,
  Omit<EnvironmentInfo, 'environment'>
> = {
  dev: {
    label: 'Dev',
    badgeClassName: 'bg-purple-700/30 text-purple-400'
  },
  preview: {
    label: 'Preview',
    badgeClassName: 'bg-yellow-500/20 text-yellow-300'
  },
  qa: {
    label: 'QA',
    badgeClassName: 'bg-orange-500/30 text-orange-400'
  },
  live: {
    label: 'Live',
    badgeClassName: 'bg-green-500/20 text-green-300'
  }
};

const QA_URL = 'https://qa-system-selector.alpinehomeair.com';
const LIVE_URL = 'https://system-selector.alpinehomeair.com';

export function getCurrentEnvironment(
  hostname: string = window.location.hostname
): Environment {
  if (hostname.startsWith('preview-')) return 'preview';
  if (hostname.startsWith('qa-')) return 'qa';
  if (hostname.endsWith('.alpinehomeair.dev') || hostname === 'localhost') {
    return 'dev';
  }
  return 'live';
}

export function getEnvironmentInfo(hostname?: string): EnvironmentInfo {
  const environment = getCurrentEnvironment(hostname);
  return { environment, ...ENVIRONMENT_DETAILS[environment] };
}

function buildEnvironmentLink(
  environment: Environment,
  baseUrl: string,
  search: string
): EnvironmentLink {
  return {
    environment,
    ...ENVIRONMENT_DETAILS[environment],
    url: `${baseUrl}${search}`
  };
}

export function getEnvironmentSwitcherLinks(
  hostname: string = window.location.hostname,
  search: string = window.location.search
): EnvironmentLink[] {
  const currentEnvironment = getCurrentEnvironment(hostname);
  const allLinks: EnvironmentLink[] = [
    buildEnvironmentLink('qa', QA_URL, search),
    buildEnvironmentLink('live', LIVE_URL, search)
  ];

  return allLinks.filter((link) => link.environment !== currentEnvironment);
}
